import React, { Component } from "react";
import { observer } from "mobx-react";
import { Accessor, ColorX, GFunc, LocaleX, ReqX, ZArray, ZTime, ZValidate } from "IZOX/STATIC";
// eslint-disable-next-line no-unused-vars
import PropsType from "prop-types";
import { HStack, Spacer, VStack, XButton, XIconButton, XText } from "IZOX/_X";
import { QFDropUpload, QFText } from "IZOX/BLOCKS/Libs/QForm/_gears";
import { QForm } from "IZOX/BLOCKS/Libs";
import { LuEye, LuEyeOff } from "react-icons/lu";
import Styles from "__SYSDefault/Styles";
import QUICKUI from "shared/QUICKUI";
import _ from "lodash";
import VarList from "shared/VarList";
import PDCContainer from "../shared/PDCContainer/PDCContainer";
import Options from "shared/Options";
import { MdClose } from "react-icons/md";

/**
 * @augments {Component<Props, State>}
 */
class PDCAcountInfoW extends Component {

  static propTypes = {

  }

  static defaultProps = {

  }

  constructor(){
    super();
    this.state = {
      tab: "contact",
      showBankAcc: false,
      editMode: false,
      contactFormValue: {},
      companyFormValue: {},
      bankFormValue: {},
      uploadBRCard: false
    };
  }

  componentDidMount(){
    this._setAllStates(() => {
      this.OnLoad();
      this.GetBankList();
    });
  }

  componentDidUpdate(prevProps, prevState){
    if(!Accessor.IsIdentical(prevProps, this.props, Object.keys(PDCAcountInfoW.defaultProps))){
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }

  _onChange = (formValue) => {
    this.setState({
      userDoc: formValue
    });
  }

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }), callback);
  }

  _addRow = (name) => {
    let {userDoc} = this.state;
    let target = Accessor.Get(userDoc, name) ?? [];
    target = [...target, ""];
    Accessor.Set(userDoc, name, target);
    this.setState({
      userDoc: userDoc
    });
  }

  _removeRow = (name, idx) => {
    let {userDoc} = this.state;
    let target = Accessor.Get(userDoc, name);
    target = ZArray.DeleteIdx(target, idx);
    Accessor.Set(userDoc, name, target);
    this.setState({
      userDoc: userDoc
    });
  }

  OnLoad = async () => {
    await this.GetUserAccountInfo();
  }

  GetBankList = async () => {
    let docs = await VarList.GetList("Bank");
    this.setState({
      banks: docs
    });
  }

  GetUserAccountInfo = async () => {
    let res = await ReqX.SendBE("/CMS/SysUser/Self", {}, null, null);
    let {Success, payload} = res;
    if(Success){
      this.setState({
        userDoc: payload
      });
    }
  }

  _selectTab = (tab) => {
    this.setState({
      tab: tab,
      editMode: false,
      uploadBRCard: false
    });
  }

  _toggleShowBankAcc = () => {
    let {showBankAcc} = this.state;
    this.setState({
      showBankAcc: !showBankAcc
    });
  }

  _toggleUploadBR = () => {
    this.setState({
      uploadBRCard: true
    });
  }

  _toEdit = () => {
    this.setState({
      editMode: true
    });
  }

  _Cancel = () => {
    this.setState({
      editMode: false
    }, () => {
      this.GetUserAccountInfo();
    });
  }

  _validate = () => {
    let {userDoc} = this.state;
    let valid = true;
    valid = ZValidate.CheckAllFields(userDoc, 
      [
        "meta.fullName.EN", 
        "meta.fullName.TC", 
        "email", 
        "telNo",
        "meta.gender", 
        "meta.dateOfBirth",
        "meta.primaryAddress.EN",
        "meta.mailingAddress.EN",
        "meta.bankPayee",
        "meta.bankID",
        "meta.bankACNo"
      ], "required");
    if(!valid) return false;
    return true;
  }

  _Submit = async (fields) => {
    let {userDoc} = this.state;
    let res = await ReqX.SendBE("/Web/DCustomer/EditUserInfo", 
      {
        form: userDoc,
        fields: fields
      }
    );
    if(res.Success){
      this._Cancel();
    }else{
      GFunc.Alert(res.payload, "error");
    }
  }

  _SubmitContact = async () => {
    this._Submit([
      "telNo",
      "email",
      "meta"
    ]);
  }

  _SubmitBank = async () => {
    this._Submit([
      "meta.bankPayee",
      "meta.bankID",
      "meta.bankACNo"
    ]);
  }

  renderPageTab(_tab, label){
    let {tab} = this.state;
    let isSelected = tab === _tab;
    return (
      <XButton onPress={() => this._selectTab(_tab)} round={0}
        padding={16}
        fullWidth
        bgColor={ColorX.CSS(isSelected ? "DeepBlueSea" : "Gray4")} color={ColorX.CSS("pureWhite")}>
        <HStack>
          <XText bold fontSize={14}>
            {LocaleX.Parse(label)}
          </XText>
        </HStack>
      </XButton>
    );
  }

  renderPageSelector(){
    return (
      <HStack spacing={5} pB={24} pH={16}>
        {this.renderPageTab("contact", {
          EN: "Personal",
          TC: "個人"
        })}
        {this.renderPageTab("bank", {
          EN: "Bank Information",
          TC: "銀行資料"
        })}
      </HStack>
    );
  }

  renderField(label, value, inject = null, width = "100%"){
    return (
      <VStack width={width} p={16}>
        <HStack HAlign="[" pV={8}>
          <XText fontSize={12} color={ColorX.CSS("Gray4")}>
            {LocaleX.Parse(label)}
          </XText>
        </HStack>
        <HStack HAlign="[">
          <XText fontSize={14}>
            {value}
          </XText>
          <Spacer/>
          {inject}
        </HStack>
      </VStack>
    );
  }

  renderLastUpdate(){
    let {userDoc} = this.state;
    let {lastModifiedAt} = userDoc ?? {};
    return (
      <HStack pV={16}>
        <XText color={ColorX.CSS("Stone")} fontSize={12}>
          {LocaleX.Parse({
            EN: "Last updated ",
            TC: "最後更新 "
          }) + (lastModifiedAt ?
            ZTime.Moment(lastModifiedAt).format("LLL") : "NULL")}
        </XText>
      </HStack>
    );
  }

  renderContact(){
    let {userDoc} = this.state;
    let {meta, telNo, email} = userDoc ?? {};
    let {fullName, dateOfBirth, agencyCode, gender, customerRefNo,
      primaryAddress, mailingAddress, additionalAddress} = meta ?? {};
    return (
      <VStack fullWidth fitHeightToContent pH={16} pB={20}>
        <VStack fullWidth bgColor={ColorX.CSS("pureWhite")}>
          <HStack>
            {this.renderField({
              EN: "Customer Ref No.",
              TC: "客戶編號"
            }, customerRefNo ?? "NULL")}
            {this.renderField({
              EN: "Agent code",
              TC: "代理號碼"
            }, agencyCode ?? "NULL")}
          </HStack>
          <HStack>
            {this.renderField({
              EN: "Full name (English)",
              TC: "全名 (英文)"
            }, fullName?.EN ?? "NULL")}
            {this.renderField({
              EN: "Full name (Chinese)",
              TC: "全名 (中文)"
            }, fullName?.TC ?? "NULL")}
          </HStack>
          <HStack>
            {this.renderField({
                EN: "Date of birth",
                TC: "出生日期"
              }, dateOfBirth ? ZTime.Moment(dateOfBirth).format("DD/MM/YYYY") : "NULL")}
            {this.renderField({
              EN: "Gender", 
              TC: "性別"
            }, gender ?? "NULL")}
          </HStack>
          <HStack>  
            {this.renderField({
              EN: "Mobile phone", 
              TC: "手機號碼"
            }, `+852 ${telNo ?? "NULL"}`)}
            {this.renderField({
              EN: "Email",
              TC: "電郵"
            }, email ?? "NULL")}
          </HStack>
          <HStack>  
            {this.renderField(
              {EN: "Primary address (English)", TC: "主要地址 (英文)"}
              , primaryAddress?.EN ?? "NULL")}
            {this.renderField(
              {EN: "Primary address (Chinese)", TC: "主要地址 (中文)"}
              , primaryAddress?.TC ?? "NULL")}
          </HStack>
          <HStack>  
            {this.renderField(
              {EN: "Mailing address (English)", TC: "郵寄地址 (英文)"}
              , mailingAddress?.EN ?? "NULL")}
            {this.renderField(
              {EN: "Mailing address (Chinese)", TC: "郵寄地址 (中文)"}
              , mailingAddress?.TC ?? "NULL")}
          </HStack>
          <VStack HAlign="[" fullWidth spacing={24}>
          {_.map(additionalAddress, (o, i) => {
            return (
              <HStack key={i}>
                {this.renderField(
                  {
                    EN: `Additional Address #${i+1} (English)`,
                    TC: `附加地址 #${i+1} (英文)`
                  }
                  , o?.EN ?? "NULL")}
              {this.renderField(
                {
                  EN: `Additional Address #${i+1} (Chinese)`,
                  TC: `附加地址 #${i+1} (中文)`
                }
                , o?.TC ?? "NULL")}
              </HStack>
            );
          })}
          </VStack>
        </VStack>
        {this.renderLastUpdate()}
        <XButton onPress={this._toEdit} 
          bgColor={ColorX.CSS("Axit")} color={ColorX.CSS("pureWhite")}
          round={50} width={242} padding={0} pH={25} pV={5}>
          <HStack>
            <XText bold>
              {LocaleX.Parse({
                EN: "Update",
                TC: "更新"
              })}
            </XText>
          </HStack>
        </XButton>
      </VStack>
    );
  }

  renderCompany(){
    let {userDoc} = this.state;
    let {meta} = userDoc ?? {};
    let {companyName,
      companyEmail, companyBRNo, officeNo, companyFax, 
      companyAddress} = meta ?? {};
    return (
      <VStack fullWidth pB={50} pH={16}>
        <VStack fullWidth bgColor={ColorX.CSS("pureWhite")}>
          <HStack>
            {this.renderField({
              EN: "Company's name (English)",
              TC: "公司名稱 (英文)"
            }, companyName?.EN ?? "NULL")}
            {this.renderField({
              EN: "Company's name (Chinese)",
              TC: "公司名稱 (中文)"
            }, companyName?.TC ?? "NULL")}
          </HStack>
          <HStack>
            {this.renderField({
              EN: "Company Address (English)",
              TC: "公司地址 (英文)"
            }, companyAddress?.EN ?? "NULL")}
          </HStack>
          <HStack>
            {this.renderField({
              EN: "Company Address (Chinese)",
              TC: "公司地址 (中文)"
            }, companyAddress?.TC ?? "NULL")}
          </HStack>
          <HStack>
            {this.renderField({
              EN: "Company email",
              TC: "公司信電郵"
            }, companyEmail)}
            {this.renderField({
              EN: "BR number",
              TC: "商業登記號碼"
            }, companyBRNo)}
          </HStack>
          <HStack>
            {this.renderField({
              EN: "Office number",
              TC: "辦公室號碼"
            }, officeNo)}
            {this.renderField({
              EN: "Contact Fax",
              TC: "聯絡傳真"
            }, companyFax)}
          </HStack>
          <HStack HAlign="[" pH={16}>
            <XText fontSize={12} color={ColorX.CSS("Gray4")}>
              {LocaleX.Parse({
                EN: "BR Card",
                TC: "商業登記卡"
              })}
            </XText>
          </HStack>
          <QFDropUpload
            fileSizeLimit={10}
            accept=".jpg,.png,.pdf,.jpeg"
            fullWidth
            readOnly
            instantUpload
            name="meta.companyBRAtth"
            noFileCaption
            previewZoneProps={{
              width: "100%",
              pB: 30,
              pH: 16
            }}
            />
          <HStack HAlign="[" pH={16}>
            <XText fontSize={12} color={ColorX.CSS("Gray4")}>
              {LocaleX.Parse({
                EN: "Employment Agency License",
                TC: "職業代理執照 (Employment Agency License)"
              })}
            </XText>
          </HStack>
          <QFDropUpload
            fileSizeLimit={10}
            accept=".jpg,.png,.pdf,.jpeg"
            fullWidth
            readOnly
            instantUpload
            name="meta.companyEALAtth"
            noFileCaption
            previewZoneProps={{
              width: "100%",
              pB: 30,
              pH: 16
            }}
            />
        </VStack>
        {this.renderLastUpdate()}
        <XButton onPress={this._toEdit}
          bgColor={ColorX.CSS("Axit")} color={ColorX.CSS("pureWhite")}
          round={50} width={242} padding={0} pH={25} pV={5}>
          <HStack>
            <XText bold>
              {LocaleX.Parse({
                EN: "Update",
                TC: "更新"
              })}
            </XText>
          </HStack>
        </XButton>
      </VStack>
    );
  }

  renderBank(){
    let {userDoc, showBankAcc, banks} = this.state;
    let {meta} = userDoc ?? {};
    let {bankACNo, bankID, bankPayee} = meta ?? {};
    let _bank = _.find(banks, o => o._id === bankID);
    return (
      <VStack fullWidth minHeight={600} pH={16}>
        <VStack fullWidth bgColor={ColorX.CSS("pureWhite")}>
          <HStack>
            {this.renderField({
              EN: "Payee",
              TC: "收款人"
            }, bankPayee ?? "NULL")}
            {this.renderField({
              EN: "Bank",
              TC: "銀行"
            }, LocaleX.Parse(_bank?.name))}
            {this.renderField({
              EN: "Bank account number",
              TC: "銀行帳號"
            }, (showBankAcc ? bankACNo : "--- ------ ---") ?? "NULL",
            <XIconButton onPress={this._toggleShowBankAcc} padding={0}>
              {showBankAcc ? <LuEye color={ColorX.CSS("Gray4")}/> 
              : <LuEyeOff color={ColorX.CSS("Gray4")} />}
            </XIconButton>)}
          </HStack>
        </VStack>
        {this.renderLastUpdate()}
        <XButton onPress={this._toEdit}
          bgColor={ColorX.CSS("Axit")} color={ColorX.CSS("pureWhite")}
          round={50} width={242} padding={0} pH={25} pV={5}>
          <HStack>
            <XText bold>
              {LocaleX.Parse({
                EN: "Update",
                TC: "更新"
              })}
            </XText>
          </HStack>
        </XButton>
      </VStack>
    );
  }

  renderButton(backFunc, nextFunc, 
    backCap = { EN: "Close", TC: "關閉" },
    nextCap = { EN: "Next", TC: "下一步"},
    validFunc = null){
    return (
      <HStack spacing={16} 
        style={{
          borderTopWidth: 1, 
          borderTopStyle: "solid",
          borderTopColor: ColorX.CSS("greyOut", 0.3)
        }} 
        HAlign="]" p={16}>
        <XButton fitWidthToContent onPress={backFunc}
          color={ColorX.CSS("Axit")}>
          <HStack>
            <XText bold>
              {LocaleX.Parse(backCap)}
            </XText>
          </HStack>
        </XButton>
        <XButton {...Styles.QFBtn} width={200} onPress={nextFunc}
          disabled={!validFunc?.()}
          padding={0} pV={8}>
          <HStack>
            <XText bold>
              {LocaleX.Parse(nextCap)}
            </XText>
          </HStack>
        </XButton>
      </HStack>
    );
  }

  renderTextField(name, label, starred, readOnly = false, width = 374, others = {}){
    return (
      <VStack width={width}>
        <HStack HAlign="[" spacing={4}>
          <XText fontSize={12} color={ColorX.CSS("Stone")}>
            {LocaleX.Parse(label)}
          </XText>
          {starred &&
            <XText fontSize={12} color={ColorX.CSS("Blood")}>{"*"}</XText>}
        </HStack>
        <QFText name={name} placeholder={LocaleX.Parse(label)} 
          readOnly={readOnly}
          p={12}
          focus_bColor={ColorX.CSS("Axit")}
          bColor={ColorX.CSS("Gray5")}
          {...others}/>
      </VStack>
    );
  }

  renderEditContact(){
    let {userDoc} = this.state;
    let additionalAddress = Accessor.Get(userDoc, "meta.additionalAddress");
    return (
      <VStack fullWidth fitHeightToContent pH={16}>
        <VStack fullWidth bgColor={ColorX.CSS("pureWhite")} pV={16}
          spacing={16}>
          <HStack spacing={16} pH={16}>
            {QUICKUI.WebTextField("meta.fullName.EN", {
              EN: "Full name (English)",
              TC: "全名 (英文)"
            }, {width: "50%"})}
            {QUICKUI.WebTextField("meta.fullName.TC", {
              EN: "Full name (Chinese)",
              TC: "全名 (中文)"
            }, {width: "50%"})}
          </HStack>
          <HStack spacing={16} pH={16}>
            {QUICKUI.WebDateField("meta.dateOfBirth",
              {EN: "Date of birth", TC: "出生日期"},
              {width: "50%"},
            )}
            {QUICKUI.WebDropdown("meta.gender",
              {EN: "Gender", TC: "性別"},
              Options.GetOptionList("Gender"),
              {width: "50%", placeholder: {EN: "Gender", TC: "性別"}},
            )}
          </HStack>
          <HStack spacing={16} pH={16}>
            {QUICKUI.WithZipCode("telNo",
              {EN: "Mobile phone", TC: "手機號碼"},
              {width: "50%"},
            )}
            {QUICKUI.WebTextField("email", {
              EN: "Email",
              TC: "電郵"
            }, {width: "50%"})}
          </HStack>
          <HStack HAlign="[" spacing={24} pH={16}>
          {QUICKUI.WebTextField("meta.primaryAddress.EN",
            {EN: "Primary address (English)", TC: "主要地址 (英文)"},
            {width: "50%"},
          )}
          {QUICKUI.WebTextField("meta.primaryAddress.TC",
            {EN: "Primary address (Chinese)", TC: "主要地址 (中文)"},
            {width: "50%", starred: false},
          )}
        </HStack>
        <HStack HAlign="[" spacing={24} pH={16}>
          {QUICKUI.WebTextField("meta.mailingAddress.EN",
            { EN: "Mailing address (English)", TC: "郵寄地址 (英文)" },
            {width: "50%"}
          )}
          {QUICKUI.WebTextField("meta.mailingAddress.TC",
            { EN: "Mailing address (Chinese)", TC: "郵寄地址 (中文)" },
            {width: "50%", starred: false}
          )}
          </HStack>
          <VStack HAlign="[" fullWidth spacing={24}>
            {_.map(additionalAddress, (o, i) => {
              return (
                <HStack VAlign="_" key={i} HAlign="[" spacing={24} pH={16}>
                  {QUICKUI.WebTextField(`meta.additionalAddress.${i}.EN`, 
                    {
                      EN: `Additional Address #${i+1} (English)`,
                      TC: `附加地址 #${i+1} (英文)`
                    }, {width: "50%", starred: false})}
                  {QUICKUI.WebTextField(`meta.additionalAddress.${i}.TC`, 
                    {
                      EN: `Additional Address #${i+1} (Chinese)`,
                      TC: `附加地址 #${i+1} (中文)`
                    }, {width: "44%", starred: false})}
                  <XButton color={ColorX.CSS("Blood")} 
                    onPress={() => this._removeRow("meta.additionalAddress", i)}>
                    <MdClose/>
                  </XButton>
                </HStack>
              );
            })}
            <XButton color={ColorX.CSS("Axit")} onPress={() => this._addRow("meta.additionalAddress")}>
              <HStack>
                <XText bold>
                  {LocaleX.Parse({
                    EN: "+ Add more address",
                    TC: "+ 增加更多地址"
                  })}
                </XText>
              </HStack>
            </XButton>
          </VStack>
        </VStack>
        {this.renderLastUpdate()}
        {this.renderButton(this._Cancel, this._SubmitContact, 
          {
            EN: "Cancel",
            TC: "取消"
          }, 
          {
            EN: "Save",
            TC: "儲存"
          }, this._validate)}
      </VStack>
    );
  }

  renderEditBank(){
    let {banks} = this.state;
    return (
      <VStack fullWidth height={600} pH={16}>
        <VStack fullWidth bgColor={ColorX.CSS("pureWhite")} pV={16}
          spacing={16}>
          <HStack spacing={16} pH={16}>
            {QUICKUI.WebTextField("meta.bankPayee", {
              EN: "Payee",
              TC: "收款人"
            }, {width: "50%"})}
            {QUICKUI.WebDropdown("meta.bankID", {
              EN: "Bank",
              TC: "銀行"
            }, banks, {width: "50%", valAccessor: "_id", capAccessor: "name"})}
            {QUICKUI.WebTextField("meta.bankACNo", {
              EN: "Bank account number",
              TC: "銀行帳號"
            }, {width: "50%"})}
          </HStack>
        </VStack>
        {this.renderLastUpdate()}
          {this.renderButton(this._Cancel, this._SubmitBank, 
          {
            EN: "Cancel",
            TC: "取消"
          }, 
          {
            EN: "Save",
            TC: "儲存"
          }, this._validate)}
      </VStack>
    );
  }

  renderMain(){
    let {tab, editMode} = this.state;
    if(editMode){
      switch(tab){
        default: case "contact": return this.renderEditContact();
        case "bank": return this.renderEditBank();
      }
    }

    switch(tab){
      default: case "contact": return this.renderContact();
      case "bank": return this.renderBank();
    }
  }

  render(){
    let {userDoc} = this.state;
    return (
      <PDCContainer>
        <VStack fullWidth bgColor={ColorX.CSS("NotQuiteWhite")}>
          <HStack HAlign="[" pV={16} pH={16}>
            <XText bold color={ColorX.CSS("Leaf")}>
              {LocaleX.Parse({
                EN: "Account Information",
                TC: "帳號資料"
              })}
            </XText>
          </HStack>
          {this.renderPageSelector()}
          <QForm value={userDoc} fullWidth onChange={this._onChange}>
            {userDoc && this.renderMain()}
          </QForm>
        </VStack>
      </PDCContainer>
    );
  }

}

export default observer(PDCAcountInfoW);
